export default __webpack_public_path__ + "media/zurb/img/contact/contact2-f519de072bfa8c6ce38101c35f8d7210.png";